import type { ISerialize } from '@/objects/ISerialize';
import { ProductionEventRace } from './ProductionEventRace';
import { ProductionEventStationRole } from './ProductionEventStationRole';

export class ProductionEvent implements ISerialize {
    public ID: number;

    public Name: string;

    public Races: ProductionEventRace[];

    public StationRoles: ProductionEventStationRole[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        Name?: string | null;
        Races?: ProductionEventRace[];
        StationRoles?: ProductionEventStationRole[];
    }) {
        this.ID = values.ID ?? 0;

        this.Name = values.Name ?? '';

        this.Races = values.Races ?? [];

        this.StationRoles = values.StationRoles ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"Races": [ ${this.Races.map((x) => (!x ? null : x?.serialize()))} ]` +
            ',' +
            `"StationRoles": [ ${this.StationRoles.map((x) => (!x ? null : x?.serialize()))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of ProductionEvent from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        Name?: string | null;
        Races?: ProductionEventRace[];
        StationRoles?: ProductionEventStationRole[];
    }): ProductionEvent {
        return new ProductionEvent(values);
    }

    public static _FromServerJson(json: any): ProductionEvent {
        return new ProductionEvent({
            ID: json.ID,
            Name: json.Name ?? '',
            Races: json.Races?.map((x: any) => ProductionEventRace._FromServerJson(x)),
            StationRoles: json.StationRoles?.map((x: any) => ProductionEventStationRole._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of ProductionEvent from another instance of ProductionEvent.
     * @param other The ProductionEvent you want to clone
     * @returns A cloned ProductionEvent
     */
    public static FromOther(other: ProductionEvent): ProductionEvent {
        return ProductionEvent._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ProductionEvent.FromOther(this);
    }

    static NAME_OF_CLASS = 'ProductionEvent';
}
